import ServiceCRUD from '../../../../../../services/ServiceCRUD';
import { apiCase as http } from '../../../../../../http';

class MatrixSLAHolidaysService extends ServiceCRUD {
  constructor() {
    super('matrix-sla-holidays');
  }

  getAllMatrixSLAHolidaysByMatrixSLAId(slaMatrixId) {
    return http.get(`${this.path}`, {
      params: {
        slaMatrixId
      }
    });
  }

  createMatrixSLAHolidays(data, usrLogin) {
    return http.post(`${this.path}`, data, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }

  updateMatrixSLAHolidays(id, data, usrLogin) {
    return http.put(`${this.path}/${id}`, data, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }

  deleteMatrixSLAHolidays(id, usrLogin) {
    return http.delete(`${this.path}/${id}`, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }
}

export default new MatrixSLAHolidaysService();
